import React from 'react'
import { Link } from 'react-router-dom'
import i18n from 'i18next'
import { Typography } from '@material-ui/core'

const Footer = () => {
  return (
    <div>
      <section className='pane reg-pane darkestgrey-pane' style={{ paddingBottom: '1rem' }}>
        <div className='row around-xs'>
          <Typography variant='caption'>
            © 2017-{new Date().getFullYear()}{' '}
            <a href='https://www.outofhandtheater.com' style={{ color: '#ffffff' }} target='_blank' rel='noopener noreferrer'>
              Out of Hand Theater
            </a>{' '}
            |{' '}
            <Link to='/privacy_policy' style={{ color: '#ffffff' }} target='_blank'>
              {i18n.t('footer.privacy')}
            </Link>{' '}
            |{' '}
            <Link to='/cookie_policy' target='blank' style={{ color: '#ffffff' }}>
              {i18n.t('footer.cookie')}
            </Link>
          </Typography>
        </div>
      </section>
    </div>
  )
}

export default Footer
